import qs from "qs";
import offerCustomPaths from "./offerCustomPaths";
import { CLICK_FUNNEL_OFFER_TYPE } from "./launchOffer";
import Cookies from "js-cookie";
import env from '../../../../environments';

type getOnboardUrlParams = {
  launchOfferType?: string;
  offerCode: string;
  isProductCatalogOffer?: boolean;
};

type UserInfo = {
  applicationId: string;
  email: string;
  email_verified: boolean;
  family_name: string;
  given_name: string;
  roles: string[];
  scope: string;
  sid: string;
  sub: string;
  tid: string;
};

const getOnboardUrl = ({
  offerCode,
  launchOfferType,
  isProductCatalogOffer,
}: getOnboardUrlParams): string | null => {
  
  const orderSystem = "directSales";
  const uuid = Date.now();
  const userDataStr = Cookies.get("user");
  const userData: UserInfo = userDataStr ? JSON.parse(userDataStr) : null;
  const emailAgent = userData?.email;
  
  const query = qs.stringify({ orderSystem, salesAgent: emailAgent, uuid });
  
  if (isProductCatalogOffer) {
    const productCatalogOfferUrl = env.PUBLISHED_OFFER_URL + offerCode;
    return `${productCatalogOfferUrl}?${query}`;
  }

  // The Chargify-era checkout /onboard/place-order/:offerCode is retired
  // (hubspot-off-block-3 task 98), so only ClickFunnels offers get a link here.
  if (launchOfferType !== CLICK_FUNNEL_OFFER_TYPE) return null;

  const locationOrigin = import.meta.env.VITE_LAUNCH_OFFER_URL;

  return `${locationOrigin}/landing-pages/${offerCustomPaths[offerCode]}?${query}`;
};

export default getOnboardUrl;